import styled from "styled-components";
import {trophyImages} from "../../../content-options/trophy";
import {useUser} from "../../../context/useUser";
import { FC} from "react";

interface Props {
    trophy: string;
    fadedtrophy: string;
    quantity: number;
    imgBottom?: string;
    shelfBottom?: string;
    imgLeft?: string;
    imgRight?: string;
    imgScale?: string;
}

const Trophy: FC<Props> = ({ trophy, fadedtrophy, quantity, imgBottom, shelfBottom, imgLeft, imgRight, imgScale }) => {

    const image = quantity ? trophyImages[trophy as keyof typeof trophyImages] : trophyImages[fadedtrophy as keyof typeof trophyImages]

    const {user} = useUser()

  return (
    <>
      <Container>
          <Img src={image} imgBottom={imgBottom} imgLeft={imgLeft} imgRight={imgRight} imgScale={imgScale} />
        
        {/* <Quantity>{quantity}</Quantity> */}
      </Container>
    </>
  );
};

export default Trophy;

const Container = styled.div`
  height: 100%;
  aspect-ratio: 1/1;
  justify-content: center;
  align-items: center;
  position: relative;

  display: flex;
  flex-direction: column;
`;

interface ImgProps {
  imgBottom?: string;
  imgLeft?: string;
  imgRight?: string;
  imgScale?: string;
}

const Img = styled.img<ImgProps>`
  height: 50%;
  aspect-ratio: 1/1;
  /* @media (min-width: 991px ) {
        max-width : 120px;
        max-height : 120px;
    } */
  position: absolute;
  z-index: 1;

  bottom: ${props => props.imgBottom || '20%'};
  left: ${props => props.imgLeft || 'auto'};
  right: ${props => props.imgRight || 'auto'};
  transform: ${props => props.imgScale ? `scale(${props.imgScale})` : 'scale(1)'};
`;
interface ShelfProps {
  shelfBottom?: string;
}

const Shelf = styled.img<ShelfProps>`
  position: absolute;
  height: 50%;
  /* aspect-ratio: 1/1; */
  /* @media (min-width: 991px ) {
        max-width : 120px;
        max-height : 120px;
    } */
  bottom: ${props => props.shelfBottom || '-10%'};
`;
const Quantity = styled.div`
  position: absolute;
  height: 33%;
  width: 33%;
  border: solid black 3px;
  right: -8%;
  bottom: 3%;
  border-radius: 50%;
  background-color: white;
  color: black;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  @media (min-width: 991px) {
    font-size: larger;
  }
`;
